import { jsx as _jsx } from "react/jsx-runtime";
import './ATS_IDBCacheComparison.scss';
import { ATS_Frontend } from '../../components/TS_AppTools/index.js';
import { RuntimeModules } from '@nu-art/ts-common';
import { ComponentSync } from '../../core/ComponentSync.js';
import { Component_CollectionGrid } from './Component_CollectionGrid.js';
export class ATS_IDBCacheComparison extends ComponentSync {
    static screen = {
        name: 'IDB<>CACHE View',
        key: 'idb<>cache',
        renderer: this,
        group: ATS_Frontend,
        modulesToAwait: () => this.getCollectionModules()
    };
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state ??= this.state ? { ...this.state } : {};
        return state;
    }
    static getCollectionModules() {
        const modules = RuntimeModules().filter((module) => !!module.dbDef?.dbKey)
            .filter(module => module.dbDef.dbKey !== 'data-input-logs');
        return modules;
    }
    render() {
        return _jsx("div", { className: 'ats__idb-cache', children: _jsx(Component_CollectionGrid, { modules: ATS_IDBCacheComparison.getCollectionModules() }) });
    }
}
//# sourceMappingURL=ATS_IDBCacheComparison.js.map